<template>
  <div class="job-assignment">
    <navbar />
    <breadcrumbs></breadcrumbs>
    
    <div class="container">
      <active-job-assignments/>
    </div>

  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import ActiveJobAssignments from '@/components/ActiveJobAssignments.vue'

export default {
  components: {
    Navbar,
    ActiveJobAssignments,
  }
}
</script>

<style>

</style>
